module.exports = __webpack_public_path__ + "static/media/portada-uniempleo.af29ced8.png";